import { IntegrationsMapping } from "../../../../integrations/IntegrationsMapping";

export const getServerCreationDateRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.aws_data?.resource_creation_date) {
    rowsMap.push({
      id: 1,
      creation_date: entityData?.aws_data?.resource_creation_date,
      source: IntegrationsMapping.aws.codeName,
    });
  }
  if (entityData?.cloudflare_data?.created_on) {
    rowsMap.push({
      id: 2,
      creation_date: entityData?.cloudflare_data?.created_on,
      source: IntegrationsMapping.cloudflare.codeName,
    });
  }
  if (entityData?.crowdstrike_data?.first_seen) {
    rowsMap.push({
      id: 3,
      creation_date: entityData?.crowdstrike_data?.first_seen,
      source: IntegrationsMapping.crowdstrike.codeName,
    });
  }
  if (entityData?.azure_vm_data?.creation_date) {
    rowsMap.push({
      id: 4,
      creation_date: entityData?.azure_vm_data?.creation_date,
      source: IntegrationsMapping.azure.codeName,
    });
  }
  if (entityData?.sentinel_one_server?.created_at) {
    rowsMap.push({
      id: 5,
      creation_date: entityData?.sentinel_one_server?.created_at,
      source: IntegrationsMapping.sentinel_one.codeName,
    });
  }
  if (entityData?.ox_data?.created_at) {
    rowsMap.push({
      id: 6,
      creation_date: entityData?.ox_data?.created_at,
      source: IntegrationsMapping.ox.codeName,
    });
  }
  if (entityData?.qualys_data?.creation_date) {
    rowsMap.push({
      id: 7,
      creation_date: entityData?.qualys_data?.creation_date,
      source: IntegrationsMapping.qualys.codeName,
    });
  }
  if (entityData?.paloalto_cortex_xdr_data?.first_seen) {
    rowsMap.push({
      id: 8,
      creation_date: entityData?.paloalto_cortex_xdr_data?.first_seen,
      source: IntegrationsMapping.paloalto_cortex_xdr.codeName,
    });
  }
  if (entityData?.servicenow_cmdb_data?.first_seen) {
    rowsMap.push({
      id: 9,
      creation_date: entityData?.servicenow_cmdb_data?.first_seen,
      source: IntegrationsMapping.servicenow_cmdb.codeName,
    });
  }
  if (entityData?.microsoft_sccm_data?.creation_date) {
    rowsMap.push({
      id: 10,
      creation_date: entityData?.microsoft_sccm_data?.creation_date,
      source: IntegrationsMapping.microsoft_sccm.codeName,
    });
  }
  if (entityData?.microsoft_defender_data?.first_seen) {
    rowsMap.push({
      id: 11,
      creation_date: entityData?.microsoft_defender_data?.first_seen,
      source: IntegrationsMapping.microsoft_defender_endpoint.codeName,
    });
  }
  if (entityData?.microsoft_active_directory_data?.creation_date) {
    rowsMap.push({
      id: 12,
      creation_date: entityData?.microsoft_active_directory_data?.creation_date,
      source: IntegrationsMapping.microsoft_active_directory.codeName,
    });
  }
  if (entityData?.imperva_waf_data?.creation_time) {
    rowsMap.push({
      id: 13,
      creation_date: entityData?.imperva_waf_data?.creation_time,
      source: IntegrationsMapping.imperva_waf.codeName,
    });
  }
  return rowsMap;
};

export const getServerLastSeenRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.crowdstrike_data?.last_seen) {
    rowsMap.push({
      id: 1,
      last_seen: entityData?.crowdstrike_data?.last_seen,
      source: IntegrationsMapping.crowdstrike.codeName,
    });
  }
  if (entityData?.sentinel_one_server?.last_seen) {
    rowsMap.push({
      id: 2,
      last_seen: entityData?.sentinel_one_server?.last_seen,
      source: IntegrationsMapping.sentinel_one.codeName,
    });
  }
  if (entityData?.qualys_data?.last_seen_date) {
    rowsMap.push({
      id: 3,
      last_seen: entityData?.qualys_data?.last_seen_date,
      source: IntegrationsMapping.qualys.codeName,
    });
  }
  if (entityData?.rapid7_insight_vm_data?.last_scan_end) {
    rowsMap.push({
      id: 4,
      last_seen: entityData?.rapid7_insight_vm_data?.last_scan_end,
      source: IntegrationsMapping.rapid7_insight_vm.codeName,
    });
  }
  if (entityData?.paloalto_cortex_xdr_data?.last_seen) {
    rowsMap.push({
      id: 5,
      last_seen: entityData?.paloalto_cortex_xdr_data?.last_seen,
      source: IntegrationsMapping.paloalto_cortex_xdr.codeName,
    });
  }
  if (entityData?.servicenow_cmdb_data?.last_seen) {
    rowsMap.push({
      id: 6,
      last_seen: entityData?.servicenow_cmdb_data?.last_seen,
      source: IntegrationsMapping.servicenow_cmdb.codeName,
    });
  }
  if (entityData?.microsoft_sccm_data?.last_seen) {
    rowsMap.push({
      id: 7,
      last_seen: entityData?.microsoft_sccm_data?.last_seen,
      source: IntegrationsMapping.microsoft_sccm.codeName,
    });
  }
  if (entityData?.microsoft_defender_data?.last_seen) {
    rowsMap.push({
      id: 8,
      last_seen: entityData?.microsoft_defender_data?.last_seen,
      source: IntegrationsMapping.microsoft_defender_endpoint.codeName,
    });
  }
  if (entityData?.microsoft_active_directory_data?.last_logon_date) {
    rowsMap.push({
      id: 9,
      last_seen: entityData?.microsoft_active_directory_data?.last_logon_date,
      source: IntegrationsMapping.microsoft_active_directory.codeName,
    });
  }
  return rowsMap;
};

export const getServerLastLaunchDateRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.aws_data?.resource_last_launch_date) {
    rowsMap.push({
      id: 1,
      last_launch: entityData?.aws_data?.resource_last_launch_date,
      source: IntegrationsMapping.aws.codeName,
    });
  }
  if (entityData?.cloudflare_data?.activated_on) {
    rowsMap.push({
      id: 2,
      last_launch: entityData?.cloudflare_data?.activated_on,
      source: IntegrationsMapping.cloudflare.codeName,
    });
  }
  if (entityData?.sentinel_one_server?.last_successful_scan_date) {
    rowsMap.push({
      id: 3,
      last_launch: entityData?.sentinel_one_server?.last_successful_scan_date,
      source: IntegrationsMapping.sentinel_one.codeName,
    });
  }
  return rowsMap;
};

export const getServerLastModifiedDateRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.aws_data?.resource_last_modified_date) {
    rowsMap.push({
      id: 1,
      last_modified: entityData?.aws_data?.resource_last_modified_date,
      source: IntegrationsMapping.aws.codeName,
    });
  }
  if (entityData?.cloudflare_data?.modified_on) {
    rowsMap.push({
      id: 2,
      last_modified: entityData?.cloudflare_data?.modified_on,
      source: IntegrationsMapping.cloudflare.codeName,
    });
  }
  if (entityData?.ox_data?.last_code_change) {
    rowsMap.push({
      id: 3,
      last_modified: entityData?.ox_data?.last_code_change,
      source: IntegrationsMapping.ox.codeName,
    });
  }

  return rowsMap;
};

export const getServerLastScanDateRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.qualys_data?.last_vulnerability_scan_date) {
    rowsMap.push({
      id: 1,
      last_scan_date: entityData?.qualys_data?.last_vulnerability_scan_date,
      source: IntegrationsMapping.qualys.codeName,
    });
  }
  if (entityData?.rapid7_insight_vm_data?.last_scan_end) {
    rowsMap.push({
      id: 2,
      last_scan_date: entityData?.rapid7_insight_vm_data?.last_scan_end,
      source: IntegrationsMapping.rapid7_insight_vm.codeName,
    });
  }

  return rowsMap;
};

export const serverHasTags = (entityData) => {
  if (
    entityData?.tags?.length > 0 ||
    entityData?.aws_data?.resource_tags?.length > 0 ||
    entityData?.azure_vm_data?.resource_tags?.length > 0 ||
    entityData?.ox_data?.tags?.length > 0 ||
    entityData?.qualys_data?.tags?.length > 0 ||
    entityData?.microsoft_defender_data?.resource_tags?.length > 0
  ) {
    return true;
  } else {
    return false;
  }
};

export const serverHasComplianceData = (entityData) => {
  return (
    entityData?.servicenow_cmdb_data?.pci_cde != null ||
    entityData?.servicenow_cmdb_data?.pci_supporting != null ||
    entityData?.servicenow_cmdb_data?.pci_supporting_asset != null ||
    entityData?.servicenow_cmdb_data?.ccpa != null ||
    entityData?.servicenow_cmdb_data?.sox != null ||
    entityData?.servicenow_cmdb_data?.pii != null ||
    entityData?.servicenow_cmdb_data?.gdpr != null ||
    entityData?.servicenow_cmdb_data?.iso_27001 != null
  );
};

export const serverHasClassificationData = (entityData) => {
  return (
    entityData?.servicenow_cmdb_data?.crown_jewel != null ||
    entityData?.servicenow_cmdb_data?.environment ||
    entityData?.servicenow_cmdb_data?.is_global != null ||
    entityData?.servicenow_cmdb_data?.sys_class_name ||
    entityData?.servicenow_cmdb_data?.sys_tags ||
    entityData?.servicenow_cmdb_data?.application_id_tag
  );
};

export const serverHasOwnershipData = (entityData) => {
  return (
    entityData?.servicenow_cmdb_data?.owning_service_owning_organization ||
    entityData?.servicenow_cmdb_data?.owning_service_owned_by ||
    entityData?.servicenow_cmdb_data?.owning_service_managed_by ||
    entityData?.servicenow_cmdb_data?.it_application_owner ||
    entityData?.servicenow_cmdb_data?.owning_service_assignment_group ||
    entityData?.servicenow_cmdb_data?.owning_company_sys_id ||
    entityData?.servicenow_cmdb_data?.used_by_companies ||
    entityData?.servicenow_cmdb_data?.owning_service_used_by_companies
  );
};

export const serverHasCodeRepository = (entityData) => {
  if (entityData?.ox_data) {
    return true;
  } else {
    return false;
  }
};

export const serverHasSecurityGroups = (entityData) => {
  if (
    entityData?.aws_data?.security_groups?.length > 0 ||
    entityData?.azure_vm_data?.security_groups?.length > 0
  ) {
    return true;
  } else {
    return false;
  }
};

export const getServerGroupsRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.crowdstrike_data?.group_names) {
    for (const group of entityData?.crowdstrike_data?.group_names) {
      rowsMap.push({
        id: rowsMap.length + 1,
        group_name: group,
        source: IntegrationsMapping.crowdstrike.codeName,
      });
    }
  }

  if (entityData?.microsoft_sccm_data?.groups) {
    for (const group of entityData?.microsoft_sccm_data?.groups) {
      rowsMap.push({
        id: rowsMap.length + 1,
        group_name: group,
        source: "microsoft_sccm",
      });
    }
  }
  if (entityData?.microsoft_defender_data?.group_name) {
    rowsMap.push({
      id: rowsMap.length + 1,
      group_name: entityData?.microsoft_defender_data?.group_name,
      source: IntegrationsMapping.microsoft_defender_endpoint.codeName,
    });
  }
  if (entityData?.microsoft_active_directory_data?.groups) {
    for (const group of entityData?.microsoft_active_directory_data?.groups) {
      rowsMap.push({
        id: rowsMap.length + 1,
        group_name: group,
        source: IntegrationsMapping.microsoft_active_directory.codeName,
      });
    }
  }
  return rowsMap;
};

export const getServerPoliciesRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.crowdstrike_data?.policies) {
    for (const policy of entityData.crowdstrike_data.policies) {
      rowsMap.push({
        id: rowsMap.length + 1,
        policy: policy,
        source: IntegrationsMapping.crowdstrike.codeName,
      });
    }
  }

  if (entityData?.paloalto_cortex_xdr_data?.assigned_extensions_policy) {
    rowsMap.push({
      id: rowsMap.length + 1,
      policy: entityData.paloalto_cortex_xdr_data.assigned_extensions_policy,
      source: IntegrationsMapping.paloalto_cortex_xdr.codeName,
      type: "Extension",
    });
  }

  if (entityData?.paloalto_cortex_xdr_data?.assigned_prevention_policy) {
    rowsMap.push({
      id: rowsMap.length + 1,
      policy: entityData.paloalto_cortex_xdr_data.assigned_prevention_policy,
      source: IntegrationsMapping.paloalto_cortex_xdr.codeName,
      type: "Prevention",
    });
  }

  return rowsMap;
};

export const getServerLoginsRows = (entityData) => {
  let rowsMap = [];

  const recentLogins = entityData?.crowdstrike_data?.recent_logins_compressed;
  if (recentLogins) {
    for (const login of recentLogins) {
      rowsMap.push({
        id: login.id || rowsMap.length + 1,
        account_name: login.account_name,
        login_timestamp: login.login_timestamp,
        login_type: login.login_type,
        login_status: login.login_status,
        is_admin: login.local_admin_privileges || "No",
        source: IntegrationsMapping.crowdstrike.codeName,
      });
    }
  }

  return rowsMap;
};

export const getServerLastUpdatedDateRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.servicenow_cmdb_data?.last_updated) {
    rowsMap.push({
      id: 1,
      last_updated: entityData?.servicenow_cmdb_data?.last_updated,
      source: IntegrationsMapping.servicenow_cmdb.codeName,
    });
  }
  if (entityData?.microsoft_active_directory_data?.last_change_date) {
    rowsMap.push({
      id: 2,
      last_updated:
        entityData?.microsoft_active_directory_data?.last_change_date,
      source: IntegrationsMapping.microsoft_active_directory.codeName,
    });
  }
  return rowsMap;
};

export const getServerPurchaseDateRows = (entityData) => {
  let rowsMap = [];

  if (entityData?.servicenow_cmdb_data?.purchase_date) {
    rowsMap.push({
      id: 1,
      purchase_date: entityData?.servicenow_cmdb_data?.purchase_date,
      source: IntegrationsMapping.servicenow_cmdb.codeName,
    });
  }
  return rowsMap;
};
